export default "__VITE_ASSET__Bt0ZRf8d__"